// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.box-bgcolor {
  background-color: rgb(255, 97, 97);
  /* top: 200px; */
  height: auto;
  display: flex;
  align-items: center;
  border-radius: 16px;
  padding-bottom: 20px;
  box-shadow: rgb(0 0 0 / 20%) 0px 4px 8px 0px, rgb(0 0 0 / 19%) 0px 6px 20px 0px;
}

.box-btnbg {
  font-family: montserrat-extrabold;
  font-weight: 800;
  font-size: 12px;
  border: 2px solid rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 25%) 0px 4px 4px inset;
  border-radius: 12px;
  background-color: rgb(255, 189, 18);
}

.lego-box-bgcolor {
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
}

.bor-color {
  border: 3px solid #18191F;
}

.lego-box-btnbg {
  background: #FFBD12;
  border: 2px solid #FFFFFF;
  box-sizing: border-box;
  box-shadow: inset 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 12px;
}

.bg1 {
  background-color: #E9E7FC
}

.bg2 {
  background-color: rgb(255, 189, 18);
}

.audio-font {
  text-align: center;
  color: rgb(255, 255, 255);
}

.lego-font {
  font-weight: 700 !important;
  /* color: #18191F !important; */
}

@media only screen and (max-width: 700px) {
  .audio-font>div>p>span {
    /* font-size: 17px !important; */
  }
  .Speakdiv {
    font-size: 19px;
  }
}

@media only screen and (max-width: 500px) {
  .audio-font>div>p>span {
    font-size: 1em !important;
  }
}

.Speakdiv {
  font-family: montserrat-medium;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.4;
  text-align: center;
  color: rgb(255, 255, 255);
}

.manage-container .logo {
  max-height: 25vh;
}

.manage-container .header-text {
  font-size: 1em;
  font-weight: bold;
  color: #000;
}

.manage-container .age-box {
  border: 1px solid #57c7af;
  padding: 5px;
  margin: 0 5px;
  flex: 1 1;
  cursor: pointer;
}
.manage-container .age-box.active {
  background: #57c7af;
  color: #fff;
  border: 1px solid #17725f;
}
.manage-container .box {
  padding: 10px 25px;
  border: 1px solid #57c7af;
  margin: 10px 25px;
  cursor: pointer;
}

.manage-container .box.active {
  background: #57c7af;
  color: #fff;
  border: 1px solid #17725f;
}
.manage-container .submit-div {
  margin: 10px 25px;
}
.manage-container .submit {
  border-color: rgb(24, 25, 31);
  border-radius: 10px;
  background: #000;
  background-color: black;
  color: white;
  padding: 10px 25px;
  border: none;
}

.manage-container .logo img {
  height: 15vh;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8JAA8J;EAC9J,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,+EAA+E;AACjF;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,8CAA8C;EAC9C,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,SAAO;EACP,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.box-bgcolor {\n  background-color: rgb(255, 97, 97);\n  /* top: 200px; */\n  height: auto;\n  display: flex;\n  align-items: center;\n  border-radius: 16px;\n  padding-bottom: 20px;\n  box-shadow: rgb(0 0 0 / 20%) 0px 4px 8px 0px, rgb(0 0 0 / 19%) 0px 6px 20px 0px;\n}\n\n.box-btnbg {\n  font-family: montserrat-extrabold;\n  font-weight: 800;\n  font-size: 12px;\n  border: 2px solid rgb(255, 255, 255);\n  box-shadow: rgb(0 0 0 / 25%) 0px 4px 4px inset;\n  border-radius: 12px;\n  background-color: rgb(255, 189, 18);\n}\n\n.lego-box-bgcolor {\n  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n  border-radius: 16px;\n}\n\n.bor-color {\n  border: 3px solid #18191F;\n}\n\n.lego-box-btnbg {\n  background: #FFBD12;\n  border: 2px solid #FFFFFF;\n  box-sizing: border-box;\n  box-shadow: inset 0px 4px 4px rgb(0 0 0 / 25%);\n  border-radius: 12px;\n}\n\n.bg1 {\n  background-color: #E9E7FC\n}\n\n.bg2 {\n  background-color: rgb(255, 189, 18);\n}\n\n.audio-font {\n  text-align: center;\n  color: rgb(255, 255, 255);\n}\n\n.lego-font {\n  font-weight: 700 !important;\n  /* color: #18191F !important; */\n}\n\n@media only screen and (max-width: 700px) {\n  .audio-font>div>p>span {\n    /* font-size: 17px !important; */\n  }\n  .Speakdiv {\n    font-size: 19px;\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  .audio-font>div>p>span {\n    font-size: 1em !important;\n  }\n}\n\n.Speakdiv {\n  font-family: montserrat-medium;\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 1.4;\n  text-align: center;\n  color: rgb(255, 255, 255);\n}\n\n.manage-container .logo {\n  max-height: 25vh;\n}\n\n.manage-container .header-text {\n  font-size: 1em;\n  font-weight: bold;\n  color: #000;\n}\n\n.manage-container .age-box {\n  border: 1px solid #57c7af;\n  padding: 5px;\n  margin: 0 5px;\n  flex: 1;\n  cursor: pointer;\n}\n.manage-container .age-box.active {\n  background: #57c7af;\n  color: #fff;\n  border: 1px solid #17725f;\n}\n.manage-container .box {\n  padding: 10px 25px;\n  border: 1px solid #57c7af;\n  margin: 10px 25px;\n  cursor: pointer;\n}\n\n.manage-container .box.active {\n  background: #57c7af;\n  color: #fff;\n  border: 1px solid #17725f;\n}\n.manage-container .submit-div {\n  margin: 10px 25px;\n}\n.manage-container .submit {\n  border-color: rgb(24, 25, 31);\n  border-radius: 10px;\n  background: #000;\n  background-color: black;\n  color: white;\n  padding: 10px 25px;\n  border: none;\n}\n\n.manage-container .logo img {\n  height: 15vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
